import React, { useEffect, useCallback, useState } from "react";
import {
  Box,
  Container,
  Grid,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import FiveSlotWorking from "./components/FiveSlotWorking";
import FiveSlotHeroBanner from "./components/FiveSlotHeroBanner";
import FiveSlotMachineCard from "./components/FiveSlotMachineCard";
import { CommonBreadcrumbs } from "../../../Components/ui";
import { Path } from "../../../../static/Constants";
import { FIVE_SLOT_CONFIG } from "./components/fiveSlotConfig";
import { colors } from "../../../../theme";
import NavBar from "../../../Components/NavBar";

import {
  getConnectedAccount,
  connectWallet as triggerConnectWallet,
  subscribeToWalletEvents,
} from "../../../../static/walletUtils";

// import slotInstance from "../../../Service/slotInstance";
// import web3 from "../../../Service/web3";

import "./FiveSlotLottery.css";

export const DUMMY_LOTTERIES = [
  {
    lotteryId: 201,
    name: "5-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "2840.50",
        seedValue: "2000.00",
        contributionPerSpin: "0.030",
      },
      major: {
        amount: "16450.00",
        seedValue: "10000.00",
        contributionPerSpin: "0.012",
      },
      mega: {
        amount: "128900.00",
        seedValue: "50000.00",
        contributionPerSpin: "0.005",
      },
    },
  },
  {
    lotteryId: 202,
    name: "5-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "1450.25",
        seedValue: "1000.00",
        contributionPerSpin: "0.030",
      },
      major: {
        amount: "8920.00",
        seedValue: "5000.00",
        contributionPerSpin: "0.012",
      },
      mega: {
        amount: "64300.50",
        seedValue: "25000.00",
        contributionPerSpin: "0.005",
      },
    },
  },
  {
    lotteryId: 203,
    name: "5-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "820.75",
        seedValue: "500.00",
        contributionPerSpin: "0.030",
      },
      major: {
        amount: "4100.80",
        seedValue: "2500.00",
        contributionPerSpin: "0.012",
      },
      mega: {
        amount: "32500.00",
        seedValue: "15000.00",
        contributionPerSpin: "0.005",
      },
    },
  },
  {
    lotteryId: 204,
    name: "5-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "4200.00",
        seedValue: "3000.00",
        contributionPerSpin: "0.030",
      },
      major: {
        amount: "24800.50",
        seedValue: "15000.00",
        contributionPerSpin: "0.012",
      },
      mega: {
        amount: "185000.00",
        seedValue: "75000.00",
        contributionPerSpin: "0.005",
      },
    },
  },
  {
    lotteryId: 205,
    name: "5-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "650.00",
        seedValue: "400.00",
        contributionPerSpin: "0.030",
      },
      major: {
        amount: "2850.00",
        seedValue: "1500.00",
        contributionPerSpin: "0.012",
      },
      mega: {
        amount: "18900.00",
        seedValue: "8000.00",
        contributionPerSpin: "0.005",
      },
    },
  },
  {
    lotteryId: 206,
    name: "5-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "5800.90",
        seedValue: "4000.00",
        contributionPerSpin: "0.030",
      },
      major: {
        amount: "34200.00",
        seedValue: "20000.00",
        contributionPerSpin: "0.012",
      },
      mega: {
        amount: "240000.00",
        seedValue: "100000.00",
        contributionPerSpin: "0.005",
      },
    },
  },
  {
    lotteryId: 207,
    name: "5-SlotBET",
    creator: "AutoBET Official",
    jackpots: {
      mini: {
        amount: "1980.30",
        seedValue: "1200.00",
        contributionPerSpin: "0.030",
      },
      major: {
        amount: "11400.00",
        seedValue: "6000.00",
        contributionPerSpin: "0.012",
      },
      mega: {
        amount: "82500.00",
        seedValue: "35000.00",
        contributionPerSpin: "0.005",
      },
    },
  },
];

const FiveSlotLottery = () => {
  const history = useHistory();

  const [account, setAccount] = useState("");
  const [lotteries, setLotteries] = useState(DUMMY_LOTTERIES);

  const fetchSlotGames = useCallback(async () => {
    /*
    try {
      if (!slotInstance?.methods?.gameId || !slotInstance?.methods?.slotGames) return;
      const totalGames = await slotInstance.methods.gameId().call();
      const count = Number(totalGames);
      if (count <= 0) return;

      const loadedGames = [];
      for (let i = 1; i <= count; i++) {
        try {
          const game = await slotInstance.methods.slotGames(i).call();
          if (game && (String(game.reels) === "5" || Number(game.reels) === 5)) {
            const minBetFormatted = web3?.utils?.fromWei
              ? web3.utils.fromWei(String(game.minBet || "0"), "ether")
              : "1.00";
            const maxBetFormatted = web3?.utils?.fromWei
              ? web3.utils.fromWei(String(game.maxBet || "0"), "ether")
              : "100.00";
            const numericMax = parseFloat(maxBetFormatted) || 100;
            const numericMin = parseFloat(minBetFormatted) || 1;

            loadedGames.push({
              lotteryId: Number(game.gameId || i),
              name: `5-SlotBET #${game.gameId || i}`,
              creator: game.owner
                ? `${game.owner.slice(0, 6)}...${game.owner.slice(-4)}`
                : "AutoBET Creator",
              owner: game.owner,
              active: game.active,
              minBet: minBetFormatted,
              maxBet: maxBetFormatted,
              jackpots: {
                mini: {
                  amount: (numericMax * 0.20).toFixed(2),
                  seedValue: (numericMax * 0.12).toFixed(2),
                  contributionPerSpin: (numericMin * 0.03).toFixed(3),
                },
                major: {
                  amount: (numericMax * 0.60).toFixed(2),
                  seedValue: (numericMax * 0.35).toFixed(2),
                  contributionPerSpin: (numericMin * 0.012).toFixed(3),
                },
                mega: {
                  amount: (numericMax * 1.50).toFixed(2),
                  seedValue: (numericMax * 0.80).toFixed(2),
                  contributionPerSpin: (numericMin * 0.005).toFixed(3),
                },
              },
            });
          }
        } catch (itemErr) {
          console.warn(`Error loading 5-slot game ${i}:`, itemErr);
        }
      }

      if (loadedGames.length > 0) {
        setLotteries([...loadedGames, ...DUMMY_LOTTERIES]);
      }
    } catch (err) {
      console.warn("Could not fetch 5-slot games from slotInstance:", err);
    }
    */
  }, []);

  const combinedPrize = lotteries
    .reduce((acc, lottery) => {
      return (
        acc +
        parseFloat(lottery.jackpots.mini.amount || 0) +
        parseFloat(lottery.jackpots.major.amount || 0) +
        parseFloat(lottery.jackpots.mega.amount || 0)
      );
    }, 0)
    .toFixed(2);

  const checkAccount = useCallback(async () => {
    const acc = await getConnectedAccount();
    setAccount(acc);
  }, []);

  const connectWallet = async () => {
    const res = await triggerConnectWallet();

    if (res.account) {
      setAccount(res.account);
    } else if (res.error === "NO_WALLET") {
      toast.error(res.message);
    } else if (res.isPending) {
      toast.info(res.message);
    } else if (!res.isCancelled && res.message) {
      toast.error(res.message);
    }
  };

  const handleOpenLottery = (lotteryId) => {
    history.push(`/five-slotlottery/${lotteryId}`);
  };

  useEffect(() => {
    checkAccount();
    fetchSlotGames();

    const unsubscribe = subscribeToWalletEvents({
      onAccountsChanged: (acc) => {
        setAccount(acc);
        fetchSlotGames();
      },
      onDisconnect: () => setAccount(""),
    });

    return unsubscribe;
  }, [checkAccount, fetchSlotGames]);

  return (
    <Box
      sx={{
        position: "relative",
        overflowX: "hidden",
        minHeight: "100vh",
        bgcolor: colors.dashboard.canvas,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ToastContainer
        position="top-right"
        autoClose={3000}
        theme="colored"
      />

      <NavBar />

      <Container
        maxWidth="xl"
        className="slot-page-container five-slot-page-container"
        sx={{
          pt: { xs: "96px", sm: "108px", md: "116px" },
          pb: 8,
          flexGrow: 1,
        }}
      >
        <Box sx={{ mb: 4 }}>
          <CommonBreadcrumbs
            items={[
              { label: "Home", path: Path.root },
              { label: "All Lotteries", path: Path.allLotteries },
              { label: `${FIVE_SLOT_CONFIG.name}` },
            ]}
          />
        </Box>

        <FiveSlotHeroBanner
          totalActive={lotteries.length}
          combinedPrize={combinedPrize}
        />

        <Grid container spacing={3} alignItems="flex-start">
          {lotteries.map((lottery) => (
            <Grid item xs={12} sm={6} lg={4} key={lottery.lotteryId}>
              <Box
                onClick={() => handleOpenLottery(lottery.lotteryId)}
                sx={{
                  cursor: "pointer",
                }}
              >
                <FiveSlotMachineCard
                  lotteryData={lottery}
                  account={account}
                  onConnectWallet={connectWallet}
                />
              </Box>
            </Grid>
          ))}
        </Grid>

        <FiveSlotWorking />
      </Container>
    </Box>
  );
};

export default FiveSlotLottery;